import { ApplicationContext } from '@hc-frontend/core-context';
import { CountMetric, TrafficSource } from '@hc-frontend/core-types';

import { PublishCount } from '../../entities';

export type TrackCountMetricUseCase = (
  metric: CountMetric,
  referer?: string,
) => Promise<void>;

type TrackCountMetricUseCaseFactory = (params: {
  publish: PublishCount;
  log: ApplicationContext['log'];
  getReferrer?: () => Promise<string>;
}) => TrackCountMetricUseCase;

export const trackCountMetricFactory: TrackCountMetricUseCaseFactory = ({
  publish,
  log,
  getReferrer,
}) => {
  return async (metric) => {
    const result = CountMetric.safeParse(metric);

    let referrer = getReferrer ? await getReferrer() : '';

    if (metric.tags.referrer && typeof metric.tags.referrer === 'string') {
      referrer = metric.tags.referrer;
    }

    let source: TrafficSource = TrafficSource.Enum.ORGANIC;

    if (referrer.match(/(sandbox|welcome)\.healthcare\.com/)) {
      source = TrafficSource.Enum.UNBOUNCE;
    } else if (
      referrer.match(/((qa\.|stg\.|local\.)*healthcare\.com)|localhost/) &&
      referrer.includes('/survey')
    ) {
      source = TrafficSource.Enum.SURVEY;
    } else if (
      referrer &&
      !referrer.match(/(qa\.|stg\.|local\.)*healthcare|healthcareinsider\.com/)
    ) {
      source = TrafficSource.Enum.CONTEXTUAL;
    }

    if (result.success) {
      publish({
        ...result.data,
        tags: { ...result.data.tags, traffic_source: source },
      });
    } else {
      log({
        message: 'The metric is not valid',
        data: {
          metricName: metric.name,
          metricTags: { ...metric.tags, traffic_source: source },
          rootCause: result.error,
        },
        context: 'client',
        type: 'error',
      });
    }
  };
};
